import { clsx, type ClassValue } from "clsx";
import { useMedia } from "react-use";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function useBreakpoints() {
  const isWideEnough = useMedia("(min-width: 768px)", false);

  return {
    isWideEnough,
  };
}
